<template>
    <div id="putGoodsInStock">
        <div class="invoicingHead" style="height:40px;">
            <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <a @click="back" href="javascript:;">入库</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>进货入库单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <table class="table" width="100%" style="table-layout:fixed" >
                <tr class="th">
                    <td>
                      <span class="mr20">进货商品</span> 
                      <el-checkbox v-model="totalClick" @change="totalChecked" style="margin-right:20px">全选</el-checkbox>
                      <el-button type="primary" plain size="mini" @click="back">取消</el-button>
                      <el-button type="primary" size="mini" @click="putGoodsInStock">入库</el-button>
                    </td>
                    <td>实际数量</td>
                </tr>
                <tr class="td" v-for="(item, index) in tableData" :key="index" style="border-bottom:1px solid red;">
                    <td style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                        <div class="flex-start">
                            <div class="flex-start mr20">
                                <el-checkbox v-model="item.click" style="margin:32px 10px 0 0;" @change="commidityClick(item,index)"></el-checkbox>
                                <img v-if="item.goodsImage" class="edit-item_img" style="margin:10px 0" :src="item.goodsImage" alt />
                                <img v-if="!item.goodsImage" class="edit-item_img" style="margin:10px 0" src="../../assets/icon/defaultPic.png" alt />
                            </div>
                            <div class="flex-column-start mt20">
                                <div>{{item.goodsName}}</div>
                                <div>未入库数量：{{(item.goodsNum - item.inputNum).toFixed(3)}}个</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="flex-end mr40" v-if="(item.goodsNum - item.inputNum) == 0.000">已全部入库</div>
                        <div class="flex-end mr20" v-else><el-input-number v-model="item.goodNum" size="small" @change="handleChange(item)" :min="0" :max="maxNum" label="描述文字"></el-input-number></div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { singleGoodsPurchase, enterGoodsPurchaseNotAll, singleGoodsChangeAll, enterGoodsChangeNotAll } from '../api';
export default {
    data() {
        return {
           userList: "",
           totalClick: false,
           tableData: [],
           orderId: "",
           maxNum: 999999999999,
           queryInfo: {
               pageNum: 1,
               row: 10
           },
           list: [],
           inStockStyle: "",
           arr: {}
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        this.userList = userList
        this.arr = JSON.parse(localStorage.getItem("detail") || "[]")
        this.inStockStyle = localStorage.getItem("inStockStyle")
        // 进货单详情
        if (this.inStockStyle == 1) {
            this.orderId = localStorage.getItem("orderId")
            this.getSingleGoodsPurchaseList()
        // 调拨单详情
        } else if (this.inStockStyle == 2) {
            this.orderId = localStorage.getItem("changeOrderId")
            this.getSingleGoodsChangeList()
        // 库存流水的进货单详情
        } else if (this.inStockStyle == 3) {
            this.orderId = this.arr.orderId
            this.getSingleGoodsPurchaseList()
         // 库存流水的调拨单详情   
        } else if (this.inStockStyle == 4) {
            this.orderId = this.arr.orderId
            this.getSingleGoodsChangeList()
        }
    },
    methods: {
        //跳转
        jumpTT(adress, message) {
            this.$router.push({ path: adress, query: { docId: message } });
        }, 
        back() {
            if (this.inStockStyle == 1) {
                this.$router.push('/invoicingFather/goodsPurchaseDetail')
            } else if (this.inStockStyle == 2) {
                this.$router.push('/invoicingFather/goodsChangeDetail')
            } else if (this.inStockStyle == 3) {
                this.$router.push('/invoicingFather/stockFlowDetail')
            } else if (this.inStockStyle == 4) {
                this.$router.push('/invoicingFather/stockFlowTransferDetail')
            }
        },
        handleChange(item) {
            this.maxNum = item.goodsNum - item.inputNum
            console.log(item, "改变添加好商品的数量")
            let reg = /^[1-9]\d*$/
            if (item.unitType == 1) {
                if (!reg.test(item.goodNum)) {
                    this.$message({
                        message: "计数商品不能为小数",
                        duration: 1000,
                        type: "error"
                    })
                    // item.goodNum = 1
                    // var index = this.tableData.findIndex(item1 => {
                    //     return item1.productId == item.productId
                    // })
                    // console.log(index)
                    // if (index !== -1) {
                    //     this.$nextTick(() => {
                    //         this.tableData[index].goodNum = 1
                    //     })
                    // }
                }
            }
            if (item.goodNum == 0) {
                this.$message({
                    message: "商品数量不能为零",
                    duration: 1000,
                    type: "error"
                })
                return
            }
            // var index = this.tableData.findIndex(item1 => {
            //     return item1.productId == item.productId
            // })
            // console.log(index)
            // if (index !== -1) {
            //     this.$set(this.tableData[index], "goodNum", item.goodNum)
            // }
        },
        // 获取调拨进货单详情列表
        getSingleGoodsChangeList() {
            singleGoodsChangeAll({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: this.queryInfo.pageNum,
                row: this.queryInfo.pageSize,
                orderId: this.orderId
            })
            .then(res => {
                if (res.code == 1) {
                    this.tableData = res.data.productJson
                    this.tableData.map(item => {
                        this.$set(item,'goodNum',item.goodsNum - item.inputNum)
                    });
                } else if (res.code == -1) {
                    this.tableData = []
                } else if (res.code == 2) {
                    this.$message.error(res.msg);
                    this.$router.push("/");
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 获取进货单详情列表
        getSingleGoodsPurchaseList() {
            singleGoodsPurchase({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: this.queryInfo.pageNum,
                row: this.queryInfo.pageSize,
                orderId: this.orderId
            })
            .then(res => {
                if (res.code == 1) {
                    this.tableData = res.data.productJson
                    this.tableData.map(item => {
                        this.$set(item,'goodNum',item.goodsNum - item.inputNum)
                    })
                } else if (res.code == -1) {
                    this.tableData = []
                } else if (res.code == 2) {
                    this.$message.error(res.msg);
                    this.$router.push("/");
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 商品是否选中
        commidityClick(item, index) {
            if (item.goodsNum - item.inputNum == 0) {
                this.$message.warning("该商品已经全部入库了哦~")
                item.click = false
                return
            }
            var arr = this.tableData;
            console.log(item.click, '商品是否选中状态');
            if (item.click == false) {
                this.totalClick = false;
                for (let i in this.list) {
                    if (this.list[i].productId == item.productId) {
                      this.list.splice(i, 1) 
                    }
                }
                console.log(this.list, "false")
            } else {
                this.totalClick = arr.every(item1 => {
                    return item1.click
                })
                this.list.push(item);
                console.log(this.list, "true")
            }
            //因为goodslist click值变化 界面checkbox状态不变
            this.tableData = "";
            this.tableData = arr;
            //
        },
        // 全选
        totalChecked() {
            var idx = this.tableData.some(item => {
                return item.goodsNum - item.inputNum == 0
            })
            if (idx) {
                this.$message.warning("该仓库已经有商品全部入库，不能全选哦~")
                this.totalClick = false 
                return
            }
            this.tableData.forEach(element => {
              element.click = this.totalClick;
            });
            if (this.totalClick) {
                this.tableData.forEach(element => {
                  this.list.push(element);
                  console.log(this.list, "全选")
                });
            } else {
              this.list = [];
            }
        },
        // 入库
        putGoodsInStock() {
            if (this.list.length == 0) {
                this.$message.error("请先选择商品")
                return
            }
            // var idx = this.list.some(item => {
            //     return item.goodsNum - item.inputNum == 0
            // })
            // if (idx) {
            //     this.$message.warning("该仓库已经全部入库了哦~")
            //     item.click = false
            //     return
            // }
            var productJson = []
            this.list.forEach(item => {
                productJson.push({
                    goodsId: item.goodsId,
                    productId: item.productId,
                    goodsNum: item.goodNum || (item.goodsNum - item.inputNum)
                })
            })
            if (this.inStockStyle == 1 || this.inStockStyle == 3) {
                enterGoodsPurchaseNotAll({
                    sessionId: this.userList.sessionId,
                    userId: this.userList.id,
                    isManager: 1, 
                    orderId: this.orderId,
                    productJson: JSON.stringify(productJson)
                })
                .then(res => {
                    if (res.code == 1) {
                        this.$message.success("操作成功");
                        if (this.inStockStyle == 1) {
                            this.$router.push('/invoicingFather/goodsPurchase')
                        } else if (this.inStockStyle == 3) {
                            this.$router.push('/invoicingFather/stockFlowList')
                        }
                    } else if (res.code == 2) {
                        this.$message.error(res.msg);
                        this.$router.push("/");
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            } else if (this.inStockStyle == 2 || this.inStockStyle == 4) {
                enterGoodsChangeNotAll({
                    sessionId: this.userList.sessionId,
                    userId: this.userList.id,
                    isManager: 1, 
                    orderId: this.orderId,
                    productJson: JSON.stringify(productJson)
                })
                .then(res => {
                    if (res.code == 1) {
                        this.$message.success("操作成功");
                        if (this.inStockStyle == 2) {
                            this.$router.push('/invoicingFather/goodsChange')
                        } else if (this.inStockStyle == 4) {
                            this.$router.push('/invoicingFather/stockFlowList')
                        }
                    } else if (res.code == 2) {
                        this.$message.error(res.msg);
                        this.$router.push("/");
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.content {
  box-sizing: border-box;
  width: calc(100vw - 250px);
  /* height: 650px; */
  /* overflow-y: scroll; */
  /* height: calc(100vh - 250px); */
  height: auto;
  padding-left: 25px;
  color: #606266;
  font-size: 14px;
  position: absolute;
  top: 120px;
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.table {
  width: 100%;
  font-size: 12px;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  /* text-align: center;     */
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.edit-item_img {
  height: 65px;
  width: 65px;
  margin-right: 20px;
}
.flex-end {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.flex-column-start {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
}
.flex-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
}
.mr20 {
    margin-right: 20px;
}
.mr40 {
    margin-right: 40px;
}
.mt20 {
    margin-top: 20px;
}
.mt5 {
    margin-top: 5px; 
}
.mr10 {
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/putGoodsInStock.vue